export default function DashboardPreviewSection() {
  const tabData = [
    {
      label: 'Bugünkü Operasyon',
      rows: [
        { hayvan: 'TR-0241-8842', islem: 'Kesim', musteri: 'Ahmet Yılmaz', durum: 'Tamamlandı', saat: '08:15' },
        { hayvan: 'TR-0241-8891', islem: 'Kesim', musteri: 'Mehmet Demir', durum: 'Sırada', saat: '09:30' },
        { hayvan: 'TR-0241-8912', islem: 'Tartım', musteri: 'Ali Kaya', durum: 'Bekliyor', saat: '10:00' },
        { hayvan: 'TR-0241-8804', islem: 'Sevk', musteri: 'Hasan Şahin', durum: 'Yolda', saat: '11:00' },
      ],
    },
    {
      label: 'Canlı Stok',
      rows: [
        { hayvan: 'TR-0241-8842', cins: 'Simental', kg: 640, parti: 'P-2026-042', durum: 'Stokta' },
        { hayvan: 'TR-0241-8891', cins: 'Holstein', kg: 580, parti: 'P-2026-041', durum: 'Satıldı' },
        { hayvan: 'TR-0241-8912', cins: 'Montofon', kg: 720, parti: 'P-2026-043', durum: 'Stokta' },
        { hayvan: 'TR-0241-8804', cins: 'Simental', kg: 490, parti: 'P-2026-040', durum: 'Kesildi' },
      ],
    },
    {
      label: 'Açık Tahsilatlar',
      rows: [
        { musteri: 'Ahmet Yılmaz', tutar: '₺42.500', vade: '15.06.2026', durum: 'Gecikti' },
        { musteri: 'Mehmet Demir', tutar: '₺18.750', vade: '20.06.2026', durum: 'Bekliyor' },
        { musteri: 'Hasan Şahin', tutar: '₺95.000', vade: '10.06.2026', durum: 'Gecikti' },
        { musteri: 'Ali Kaya', tutar: '₺31.200', vade: '25.06.2026', durum: 'Bekliyor' },
      ],
    },
  ];

  return (
    <section id="dashboard" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Tüm operasyon tek ekranda.
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            CiftlikWeb yönetim paneli sayesinde anlık durumu, riskleri ve operasyon akışını tek bakışta görün.
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden shadow-sm">
          <div className="bg-foreground-950 px-5 py-3 flex items-center gap-2">
            <div className="flex gap-1.5">
              <div className="w-3 h-3 rounded-full bg-red-400"></div>
              <div className="w-3 h-3 rounded-full bg-amber-400"></div>
              <div className="w-3 h-3 rounded-full bg-green-400"></div>
            </div>
            <span className="text-background-50/80 text-xs ml-3 font-heading">CiftlikWeb Paneli</span>
          </div>

          <div className="p-4 md:p-6">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 mb-6">
              <div className="bg-primary-50 rounded-lg p-4 border border-primary-100/50">
                <p className="text-xs text-foreground-500 mb-1">Aktif Hayvan</p>
                <p className="text-xl md:text-2xl font-bold text-foreground-950">128</p>
              </div>
              <div className="bg-accent-50 rounded-lg p-4 border border-accent-100/50">
                <p className="text-xs text-foreground-500 mb-1">Bugünkü Kesim</p>
                <p className="text-xl md:text-2xl font-bold text-foreground-950">42</p>
              </div>
              <div className="bg-secondary-50 rounded-lg p-4 border border-secondary-100/50">
                <p className="text-xs text-foreground-500 mb-1">Açık Tahsilat</p>
                <p className="text-xl md:text-2xl font-bold text-foreground-950">₺1.245K</p>
              </div>
              <div className="bg-accent-50 rounded-lg p-4 border border-accent-100/50">
                <p className="text-xs text-foreground-500 mb-1">Hisse Doluluk</p>
                <p className="text-xl md:text-2xl font-bold text-foreground-950">%78</p>
              </div>
            </div>

            <div className="flex gap-1 mb-4 overflow-x-auto">
              {tabData.map((tab, i) => (
                <button
                  key={i}
                  className={`px-4 py-2 text-xs font-medium rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                    i === 0
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200">
                    {Object.keys(tabData[0].rows[0]).map((key) => (
                      <th key={key} className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                        {key}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tabData[0].rows.map((row, ri) => (
                    <tr key={ri} className="border-b border-background-100 hover:bg-background-50 transition-colors">
                      {Object.values(row).map((val, ci) => (
                        <td key={ci} className="py-2.5 px-3 text-sm text-foreground-700">
                          {val === 'Tamamlandı' || val === 'Stokta' ? (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium">
                              {val}
                            </span>
                          ) : val === 'Gecikti' ? (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium">
                              {val}
                            </span>
                          ) : val === 'Sırada' || val === 'Yolda' ? (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium">
                              {val}
                            </span>
                          ) : (
                            String(val)
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
